import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { Complement } from '../complement';
import { parseNumber } from '../../utils/number.utils';
import { ComplementTypeBuilder } from './complement-type-builder';
import { BrandBuilder } from './brand.builder';

export class ComplementBuilder {

  static fromJson(json): Complement {
    return (json) ? new Complement(
      json.hash,
      json.name,
      json.code,
      parseNumber(json.price),
      parseNumber(json.weight),
      json.needSerialNumber,
      json.description,
      json.complementType ? ComplementTypeBuilder.fromJson(json.complementType) : null,
      json.brand ? BrandBuilder.fromJson(json.brand) : null,
    ) : null;
  }

  static fromJsonList(list): Complement[] {
    return (isArray(list)) ? sortByString('name', mapCollection(ComplementBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/complement-builder.ts